export const FLIGHT_TYPE = 'Relocation::Flight';
export const TRANSFER_TYPE = 'Relocation::Transfer';
export const FLIGHTS_MODAL = 'ADD_FLIGHTS';
export const MANUALLY_MODAL = 'ADD_MANUALLY';
